import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ReportWorkflowBrief } from '@core//models/report-workflow-brief.model';
import { ReportWorkflowDetail } from '@core//models/report-workflow-detail.model';
import { ErrorDetail, IQuery, PaginatedResults } from '@utils';
import { first, map } from 'rxjs/operators';

import { API_URL } from '../../core.tokens';


@Injectable()
export class ReportWorkflowService {

  constructor(
    private http: HttpClient,
    @Inject(API_URL) private apiUrl: string
  ) { }

  getByQuery(query: IQuery) {
    return this.http.post<PaginatedResults<ReportWorkflowBrief>>(`${this.apiUrl}/workflow/report/query`, query).pipe(first());
  }

  getById(id: number) {
    return this.http.get<ReportWorkflowDetail>(`${this.apiUrl}/workflow/report/${id}`).pipe(first());
  }

  getJson(id: number) {
    return this.http.get<string>(`${this.apiUrl}/workflow/${id}/json`).pipe(first(), map(json => JSON.stringify(json, null, '\t')));
  }

  verifyHash(id: number, hash: string) {
    return this.http.get<ErrorDetail[]>(`${this.apiUrl}/workflow/${id}/verify-hash/${hash}`).pipe(first());
  }
}
